import { EntityType } from 'UI/constants/entityTypes';

export const QUERY_PARAMS_BY_ENTITY_TYPE = {
  [EntityType.Candidate]: {
    ids: null,
    includes: 'specialty,subspecialty,position,personalInformation',
    page: 1,
    perPage: 100
  },
  [EntityType.Joborder]: {
    ids: null,
    page: 1,
    perPage: 100
  }
};

export const ERROR_RESPONSE_CUSTOM_CODES = {
  NotEnoughData: 'not-enough-data'
};
